import * as b_ from 'b_';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'shared/components/Link';
import { compose } from 'recompose';
import { FieldSet } from 'shared/components/FieldSet';
import { Input } from 'shared/components/Input';
import SubmitButton from 'shared/components/SubmitButton';
import { form, FormProps } from 'shared/utils/form';
import { validate } from 'shared/utils/validators';
import { routine } from './actions';
import { constraints, FormData } from './constraints';

import './index.scss';

export interface Props {
  source: string;
  landing: string;
}

type Enhanced = Props & FormProps<FormData, Props>;

const enhance = compose<Enhanced, Props>(
  form(routine, {
    form: 'fullRegistrationPersonalData',
    validate: (values) => validate(constraints, values),
    destroyOnUnmount: false,
  })
);

const b = b_.with('full-registration-personal-data-form');

const PersonalDataForm: React.FC<Enhanced> = ({ formSubmit, submitting, error }) => {
  const { t } = useTranslation();
  return (
    <form onSubmit={formSubmit} method="POST" data-testid="signup-popup-personal-data-step">
      <FieldSet>
        <Input
          name="firstName"
          label={t('firstName')}
          autoFocus
          tooltipPlacement="bottomLeftSticky"
        />
        <Input name="lastName" label={t('lastName')} tooltipPlacement="bottomLeftSticky" />
      </FieldSet>
      <FieldSet>
        <Input name="email" label={t('email')} type="email" tooltipPlacement="bottomLeftSticky" />
        <Input
          name="phone"
          label={t('phone')}
          type="phone"
          placeholder={t('phone example')}
          tooltipPlacement="bottomLeftSticky"
        />
      </FieldSet>
      <div className="row">
        <SubmitButton
          primary
          submitting={submitting}
          error={error}
          data-gtm="registrationform-firststep-btn"
        >
          {t('Next')}
        </SubmitButton>
        <p className="text-secondary">
          {t('By clicking Next you accept')}{' '}
          <Link to="/offer" target="_blank" className={b('offer-link')}>
            {' '}
            {t('Licence Agreement')}
          </Link>
        </p>
      </div>
    </form>
  );
};

export default enhance(PersonalDataForm);
